var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{staticClass:"subAlert",attrs:{"type":"warning","show-icon":"","closable":false},nativeOn:{"click":function($event){return _vm.infoComplete.apply(null, arguments)}}},[_c('span',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticStyle:{"color":"#3085fc"}},[_vm._v("点击前往")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }